<nb-menu id="sidebar-menu" tag="sidebar-menu" [items]="items" autoCollapse="true"></nb-menu>

<a href="https://www.ethinking.de" class="header-logo" target="_blank"  rel="noopener noreferrer">
    <img src="assets/images/ethinking-logo.svg" height="50" alt="ethinking">
</a>
